// extracted by mini-css-extract-plugin
module.exports = {"container":"SchoolpageZittenblijven_container_1yLcC","empty":"SchoolpageZittenblijven_empty_2aaGQ"};